import { FC } from "react";
import { StepsProps } from "../../types";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useStep3 from "./useStep3";
import { FormCheckbox, FormSectionHeader, Loader } from "@/components";
import {
  ADS,
  DISPLAY_EMAIL,
  DISPLAY_LANDLINE,
  DISPLAY_MOBILE,
  DISPLAY_NAME,
  OPT_EMERGENCY,
  OPT_GENERAL,
  PARTNER_EMAIL,
  PROP_ADDRESS,
  SMS_PAST_DUE,
} from "./consts";

const Step3: FC<StepsProps> = ({ onCancel, isView }) => {
  const {
    form,
    requiredFields,
    isLoadingUserPreference,
    isUserPreferenceRefetching,
  } = useStep3();
  const { errors } = form.formState;

  return isLoadingUserPreference || isUserPreferenceRefetching ? (
    <Loader />
  ) : (
    <FormProvider {...form}>
      <form>
        <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
          <div>
            <FormSectionHeader>User Preference</FormSectionHeader>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormCheckbox
                name={SMS_PAST_DUE}
                control={form.control}
                label="SMS for Past Due"
                error={errors[SMS_PAST_DUE]?.message}
                isRequired={requiredFields.includes(SMS_PAST_DUE)}
                disabled={isView}
              />
              <FormCheckbox
                name={OPT_GENERAL}
                control={form.control}
                label="Opt In General"
                error={errors[OPT_GENERAL]?.message}
                isRequired={requiredFields.includes(OPT_GENERAL)}
                disabled={isView}
              />
              <FormCheckbox
                name={OPT_EMERGENCY}
                control={form.control}
                label="Opt In Emergency"
                error={errors[OPT_EMERGENCY]?.message}
                isRequired={requiredFields.includes(OPT_EMERGENCY)}
                disabled={isView}
              />
              <FormCheckbox
                name={DISPLAY_NAME}
                control={form.control}
                label="Display Name"
                error={errors[DISPLAY_NAME]?.message}
                isRequired={requiredFields.includes(DISPLAY_NAME)}
                disabled={isView}
              />
              <FormCheckbox
                name={PROP_ADDRESS}
                control={form.control}
                label="Display Prop Address"
                error={errors[PROP_ADDRESS]?.message}
                isRequired={requiredFields.includes(PROP_ADDRESS)}
                disabled={isView}
              />
              <FormCheckbox
                name={DISPLAY_EMAIL}
                control={form.control}
                label="Display Email Address"
                error={errors[DISPLAY_EMAIL]?.message}
                isRequired={requiredFields.includes(DISPLAY_EMAIL)}
                disabled={isView}
              />
              <FormCheckbox
                name={DISPLAY_MOBILE}
                control={form.control}
                label="Display Mobile"
                error={errors[DISPLAY_MOBILE]?.message}
                isRequired={requiredFields.includes(DISPLAY_MOBILE)}
              />
              <FormCheckbox
                name={DISPLAY_LANDLINE}
                control={form.control}
                label="Display Landline"
                error={errors[DISPLAY_LANDLINE]?.message}
                isRequired={requiredFields.includes(DISPLAY_LANDLINE)}
                disabled={isView}
              />
              <FormCheckbox
                name={ADS}
                control={form.control}
                label="Opt In Partner Online Ads "
                error={errors[ADS]?.message}
                isRequired={requiredFields.includes(ADS)}
                disabled={isView}
              />
              <FormCheckbox
                name={PARTNER_EMAIL}
                control={form.control}
                label="Opt In Partner Emails"
                error={errors[PARTNER_EMAIL]?.message}
                isRequired={requiredFields.includes(PARTNER_EMAIL)}
                disabled={isView}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between items-center  py-3">
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button variant="outline" type="button" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Step3;
